import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import PocketBase from 'pocketbase';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  isCollapsed = true;
  showSettingsMenu = false;

  constructor(private router: Router) {}

  toggleNavbar() {
    this.isCollapsed = !this.isCollapsed;
  }

  clearCacheAndReload() {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('assetTableFilters');
      window.location.reload();
    }
  }

  toggleSettingsMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.showSettingsMenu = !this.showSettingsMenu;
  }

  closeSettingsMenu() {
    this.showSettingsMenu = false;
  }

  async logout() {
    const result = await Swal.fire({
      title: 'ออกจากระบบ?',
      text: 'คุณต้องการออกจากระบบหรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ออกจากระบบ',
      cancelButtonText: 'ยกเลิก',
      reverseButtons: true
    });
    if (result.isConfirmed) {
      const pb = new PocketBase('/');
      await pb.authStore.clear();
      this.router.navigate(['/login']);
    }
  }
}
